module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "salaryslider",
    staticClass: "slider-group form-group"
  }, [_c('label', [_vm._v(_vm._s(_vm.lng.salary) + "\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "slider-group-box"
  }, [_c('div', {
    staticClass: "slider-input-box"
  }, [_c('input', {
    ref: "sfrom",
    staticClass: "numfield slider-group-box__input  slider-group-box__input_salary",
    attrs: {
      "type": "text",
      "data-ref": "salary",
      "data-refval": "first"
    },
    domProps: {
      "value": _vm.salary.value[0]
    }
  }), _vm._v(" "), _c('span', [_vm._v(" - ")]), _vm._v(" "), _c('input', {
    ref: "sto",
    staticClass: "numfield slider-group-box__input slider-group-box__input_salary",
    attrs: {
      "type": "text",
      "data-ref": "salary",
      "data-refval": "second"
    },
    domProps: {
      "value": _vm.salary.value[1]
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-slider",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handlerSendSalary.apply(null, arguments)
      }
    }
  }, [_vm._v("Set")])]), _vm._v(" "), _c('vue-slider', _vm._b({
    ref: "salary",
    on: {
      "drag-end": _vm.stopDrag
    },
    model: {
      value: (_vm.salary.value),
      callback: function($$v) {
        _vm.$set(_vm.salary, "value", $$v)
      },
      expression: "salary.value"
    }
  }, 'vue-slider', _vm.salary, false))], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/PhpstormProjects/e-crewing/~/vue-loader/lib/template-compiler.js?id=data-v-27aa3934!C:/PhpstormProjects/e-crewing/~/vue-loader/lib/selector.js?type=template&index=0!./vue/frontfilter/components/Salary.vue
// module id = 50
// module chunks = 0 1